import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './dropdown.component';
import { TextFilterPipe } from './dropdownfilter.pipe';
import { FormsModule } from '@angular/forms';
//import { SharedModule } from '@app/shared/shared.module';
// import { InfiniteScrollModule } from 'ngx-infinite-scroll';;
// import {CheckboxModule} from '@shared/components/checkbox/checkbox.module';
// import {CheckboxComponent} from '@shared/components/dropdown/shared/components/checkbox/checkbox.component';


@NgModule({
    declarations: [DropdownComponent, TextFilterPipe],
    imports: [
        CommonModule,
        FormsModule,
        //InfiniteScrollModule,

        // Libraries
      //haredModule,
    ],
    exports: [DropdownComponent, TextFilterPipe],
})
export class DropdownModule {
}
